import { useState } from "react";
import SelectCar from "./SelectCar";
import "./LeftSideCarwashFactor.scss";
import NumericFunction from "../../../utils/NumericFunction";
import commaSeparator from "../../../utils/CommaSeparator";
import Input from "../../UI/Input";
import utilsFunction from "../../../utils/utilsFunction";
import { toast } from "react-toastify";
import _axios from "../../../httpService";
import ModalToSelectCar from "./ModalToSelectCar";
import { prefixUrl } from "../../../utils/utilsData";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Modal, { ModalBody, ModalHeader } from "../../Modal";
import Form from "../../Form/Form";

const LeftSide = ({
  initialData,
  setSendData,
  sendData,
  factorData,
  setFactorData,
  factorDataNoTax,
  customId,
}) => {
  const navigateTo = useNavigate();
  const sendDataSetter = (keyValuePairs) => {
    setSendData({ ...sendData, ...keyValuePairs });
  };
  const [paymentModalIsOpen, setPaymentModalIsOpen] = useState(false);
  function paymentModalCallbackHandler({ isOpen }) {
    setPaymentModalIsOpen(isOpen);
  }
  console.log(customId);
  const factorDataSetter = (keyValuePairs) => {
    setFactorData({ ...factorData, ...keyValuePairs });
  };
  const OpenModalToSelectCar = () => {
    factorDataSetter({
      isOpenModalSelectCarRLookUp: !factorData.isOpenModalSelectCarRLookUp,
    });
  };
  const submitHandler = () => {
    console.log(sendData);

    if (sendData.products.length <= 0 && sendData.services.length <= 0) {
      toast.error("انتخاب خدمت یا محصول اجباری است.");
      return;
    }

    if (sendData.IDKHOD === "" || sendData.IDKHOD === undefined) {
      toast.error("انتخاب خودرو اجباری است.");
      return;
    }

    _axios.post(prefixUrl() + "/carwashFactor/", sendData).then((res) => {
      const data = res.data;
      if (data.status) {
        setSendData({
          IDKHOD: "",
          status: "inQueue", // inProcess
          services: [],
          reward: "",
          products: [],
          discount: "",
          tax: "",
        });
        setFactorData({
          isOpenModalSelectCarRLookUp: false,
          rLookUpData: {
            na_16: "",
            na_20: "",
          },
          isOpenSelectWorkerModal: false,
          lastServiceSelectedId: "",
          sum: 0,
        });
        toast.success("ثبت موفقیت آمیز");
        navigateTo(-1);
      } else {
        toast.error(res.data.message);
      }
    });
  };
  const paymentHandler = () => {
    setPaymentModalIsOpen(true);
  };

  return (
    <>
      {factorData.isOpenModalSelectCarRLookUp && (
        <>
          <ModalToSelectCar
            id={initialData?.rLookUpId}
            callBackDataHandler={(incomingData) => {
              console.log(incomingData);
              factorDataSetter({
                rLookUpData: incomingData,
                isOpenModalSelectCarRLookUp: false,
              });
              setSendData({ ...sendData, IDKHOD: incomingData });
            }}
            modalHandler={[
              factorData.isOpenModalSelectCarRLookUp,
              (isOpen) => {
                factorDataSetter({ isOpenModalSelectCarRLookUp: isOpen });
              },
            ]}
          />
        </>
      )}

      <div className="left-sideCarwash-parent" style={{ width: "30%" }}>
        <SelectCar
          OpenModalToSelectCar={OpenModalToSelectCar}
          sendData={sendData}
          factorData={factorData}
          sendDataSetter={sendDataSetter}
          setFactorData={setFactorData}
        />
        <div className="my-3 reward__box">
          <div className="reward__title">
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="5.5" cy="13.5" r="5.5" fill="#33B0B1" />
              <circle cx="15.5" cy="2.5" r="2.5" fill="#009C9D" />
            </svg>
            <h2>انعام</h2>
          </div>
          <div>
            <div className="prices__parent">
              {initialData?.rewards?.map((v, index) => (
                <div
                  key={index}
                  className={
                    sendData?.reward === v.price ? "btn__price " : "btn__price"
                  }
                  onClick={() => sendDataSetter({ reward: v.price })}
                >
                  {NumericFunction.e2p(commaSeparator(v.price))} تومان{" "}
                </div>
              ))}
            </div>

            <div className={"select_car_amount"}>
              <Input
                onChange={(e) => {
                  sendDataSetter({
                    reward: NumericFunction.p2e(
                      utilsFunction.removeComma(e.target.value)
                    ),
                  });
                }}
                id={"price"}
                value={
                  "" +
                  NumericFunction.e2p(commaSeparator(sendData?.reward) + "")
                }
                type={"text"}
                placeholder={"مبلغ مورد نظر را وارد کنید"}
              />

              <svg
                onClick={() => sendDataSetter({ reward: "" })}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
                  fill="#FB6B7A"
                />
                <path
                  d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
                  fill="#FB6B7A"
                />
                <path
                  d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                  fill="#FB6B7A"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* مبلغ تخفیف و.... */}
        <div className="sale__box_parent">
          <div className="sale__box">
            <div className="input_group">
              <label>تخفیف:</label>
              <Input
                onChange={(e) =>
                  sendDataSetter({
                    discount: NumericFunction.p2e(
                      utilsFunction.removeComma(e.target.value)
                    ),
                  })
                }
                value={
                  "" +
                  NumericFunction.e2p(commaSeparator(sendData?.discount) + "")
                }
                type={"text"}
              />
            </div>
            <div className="input_group total__">
              <div className="set-inline-flex">
                <label>مالیات:</label>
                <span>
                  {sendData?.tax !== 0
                    ? NumericFunction.e2p(
                        commaSeparator(
                          (factorDataNoTax * sendData.tax) / 100
                        ).toString()
                      )
                    : ""}
                </span>
              </div>

              {/*<Input*/}
              {/*    disable true*/}
              {/*    id={"tax"}*/}
              {/*    className={"my-1"}*/}
              {/*    // onChange={(e) => sendDataSetter({tax: e.target.value})}*/}
              {/*    value={sendData?.tax !== 0 ? NumericFunction.e2p(commaSeparator(factorDataNoTax * initialData.tax) / 100) : ""}*/}
              {/*    type={"text"}/>*/}
            </div>
          </div>
          <div className="total__">
            <span>
              {NumericFunction.e2p(commaSeparator(factorData.sum))} تومان
            </span>
            <button className="submit__btn" onClick={submitHandler}>
              ثبت
            </button>
          </div>
          <button className="submit__btn" onClick={paymentHandler}>
            پرداخت
          </button>
        </div>
        <Modal
          isOpen={paymentModalIsOpen}
          modalCallback={paymentModalCallbackHandler}
        >
          <ModalHeader title={"افزودن"} />
          <ModalBody>
            <Form id={"304-s"} factorId={customId} price={factorData.sum} />
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};
export default LeftSide;
